import { render } from "./breadCrumb.vue?vue&type=template&id=4084ded8&scoped=true&ts=true"
import script from "./breadCrumb.vue?vue&type=script&lang=ts"
export * from "./breadCrumb.vue?vue&type=script&lang=ts"

import "./breadCrumb.vue?vue&type=style&index=0&id=4084ded8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4084ded8"]])

export default __exports__